const ADDRESS_LOWERCASE_WORDS = new Set([
  "da",
  "de",
  "do",
  "das",
  "dos",
  "e",
  "a",
  "o",
]);

export function formatAddressTitleCase(text: string): string {
  if (!text || typeof text !== "string") return text;
  return text
    .trim()
    .split(/\s+/)
    .map((word, index) => {
      const lower = word.toLowerCase();
      if (index > 0 && ADDRESS_LOWERCASE_WORDS.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}

export function formatName(name: string): string {
  if (name) {
    return name
      .toLowerCase()
      .replace(/-/g, " - ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } else {
    return "Texto nao encontrado";
  }
}

// Lista de siglas de estados brasileiros (constante compartilhada)
const BRAZILIAN_STATE_ABBREVIATIONS = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

// Função base para formatar cidades com controle sobre sigla do estado
function formatCityBase(cityString: string, includeState: boolean): string {
  if (!cityString) {
    return "Texto não encontrado";
  }

  // Divide a string em partes usando hífens
  const parts = cityString.toLowerCase().split("-");

  if (parts.length === 0) return cityString;

  // A última parte pode ser uma sigla de estado
  const lastPart = parts[parts.length - 1].toUpperCase();
  const isStateAbbrev = BRAZILIAN_STATE_ABBREVIATIONS.includes(lastPart);

  let formattedParts: string[];
  let stateAbbrev = "";

  if (isStateAbbrev) {
    // Se a última parte é uma sigla de estado, separa ela
    formattedParts = parts.slice(0, -1);
    stateAbbrev = lastPart;
  } else {
    // Se não, trata tudo como nome da cidade
    formattedParts = parts;
  }

  // Capitaliza cada parte do nome da cidade
  const formattedCity = formattedParts
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

  // Retorna com ou sem sigla do estado baseado no parâmetro
  return includeState && stateAbbrev
    ? `${formattedCity} - ${stateAbbrev}`
    : formattedCity;
}

// Função para formatar nomes de cidades com siglas de estados
export function formatCityWithState(cityString: string): string {
  return formatCityBase(cityString, true);
}

// Função para formatar nomes de cidades sem siglas de estados
export function formatCityWithoutState(cityString: string): string {
  return formatCityBase(cityString, false);
}

// Função para padronizar categorias de assentos
export function normalizeSeatClass(seatClass?: string | null): string {
  if (!seatClass) {
    return "CONVENCIONAL";
  }

  const normalizedClass = seatClass.toUpperCase().replace(/-/g, "");

  if (normalizedClass.includes("CAMA")) {
    return "Cama";
  }

  if (normalizedClass.includes("LEITO")) {
    return "Leito";
  }

  if (
    normalizedClass.includes("SEMILEITO") ||
    normalizedClass.includes("SEMI")
  ) {
    return "Semi Leito";
  }

  if (normalizedClass.includes("EXECUTIVO")) {
    return "Executivo";
  }

  if (
    normalizedClass.includes("CONVENCIONAL") ||
    normalizedClass.includes("CONV")
  ) {
    return "Convencional";
  }

  return "Convencional";
}
